module.exports = "https://cdn-social.hiplatform.com/images/945cd613591ee44835740f64bb2c79e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/sendEmail.svg
// module id = NoVW
// module chunks = 0